__turbopack_context__.v({
  "caption": "styles-module-scss-module__0q9Dbq__caption",
  "classNameContent": "styles-module-scss-module__0q9Dbq__classNameContent",
  "classNameRoot": "styles-module-scss-module__0q9Dbq__classNameRoot",
  "content": "styles-module-scss-module__0q9Dbq__content",
  "description": "styles-module-scss-module__0q9Dbq__description",
  "root": "styles-module-scss-module__0q9Dbq__root",
  "title": "styles-module-scss-module__0q9Dbq__title",
});
